<template>
  <div class="p-3 main-create-question-topic">
    <div id="pop-up" v-if="loading == true">
      <div class="">
        <b-spinner
          variant="primary"
          style="width: 4rem; height: 4rem"
          label=""
        ></b-spinner>
      </div>
    </div>
    <div class="createQuestion">
      <b-modal id="modal-create-question" size="xl" hide-header hide-footer>
        <create-question :callback="getOneTopic" :titleTopic="titleTopic" :rowTopicItem="rowTopicItem"></create-question>
      </b-modal>
      <b-modal id="modal-create-question-auto-of-exam" size="xl" hide-header hide-footer>
        <create-question-auto-of-exam :callback="getOneTopic" :titleTopic="titleTopic" :rowTopicItem="rowTopicItem"></create-question-auto-of-exam>
      </b-modal>
      <b-modal id="modal-edit-question" size="xl" hide-header hide-footer>
        <!-- <edit-question :idQuestion="idQuestion"></edit-question> -->
        <edit-question :callback="getOneTopic" :titleTopic="titleTopic" :rowTopicItem="rowTopicItem"></edit-question>
      </b-modal>
      <b-row class="d-flex justify-content-end">
        <b-col>
            <h5 class="titleTopic">
                {{ form.title }}
            </h5>
        </b-col>
        <b-col cols="3" class="create_group_question">
          <b-row class="text-center btn-create-question-in-topic">
            <b-col
              cols="12"
              class="create-button"
              @click="showCreateQuestion()"
            >
              <b-icon-plus-circle-fill
                style="color: green;"
              ></b-icon-plus-circle-fill>
              {{ $t("question_list.create_group_question") }}
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="3" class="create_group_question">
          <b-row class="text-center btn-create-question-in-topic">
            <b-col
              cols="12"
              class="create-button"
              @click="showCreateQuestionAutoOfExam()"
            >
              <b-icon-plus-circle-fill
                style="color: green;"
              ></b-icon-plus-circle-fill>
              {{ $t("question_list.create_group_question_auto_of_exam") }}
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!--
      <div class="">
        <div class="row justify-content-around">
          <div class="col left-embed p-0">
            <div
              class="d-flex flex-column align-items-center embed-image-video"
            >
              <div v-if="!imageUpload && !getVideoPath && !embedPath" id="preview" class="">
                <img src="../Rectangle.png" />
              </div>
              <div v-else id="preview" class="">
                <img v-if="imageUpload" :src="imageUpload" />
                <img v-if="embedPath && !embedPath.includes(`/embed/`)" :src="embedPath" />
                <iframe :src="embedPath"
                        class="iframe"
                        v-if="embedPath && embedPath.includes(`/embed/`)"
                        title="YouTube video player" frameborder="0"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
                <video
                  style="width:450px"
                  v-if="getVideoPath"
                  :src="getVideoPath"
                  id="video-container"
                  controls
                ></video>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <div class="upload-audio" v-if="!embedAudio && !getAudioPath">
                <button
                  class="upload-audio-button"
                  for="upload-audio-input"
                  type="button"
                >
                  <b-icon
                    icon="music-note-beamed"
                    font-scale="1.5"
                    style="margin-right: 5px"
                    variant="danger"
                  ></b-icon>
                  <label >{{ $t("question_list.label.audio") }}</label>
                </button>
                <b-form-file
                  accept="audio/*"
                  class="pr-1"
                  id="upload-audio-input"
                ></b-form-file>
              </div>
              <audio
                :src="getAudioPath"
                id="audio-preview"
                controls
                v-if="getAudioPath"
              />
            </div>
            <div  id="audio_embed_view" v-html="embedAudio">
                {{ embedAudio }}
              </div>
            <div  class="embed-audio d-flex flex-row" v-if="!embedAudio && !getAudioPath">
              <b-button>
                <b-icon
                  icon="box-arrow-up"
                  font-scale="1.2"
                  variant="success"
                ></b-icon>
                <span>{{ $t("question_list.label.embed_video_audio") }}</span>
              </b-button>
              <input  disabled v-model="embedAudio" type="text" />
            </div>
            <div class="question-input__textArena">
              <textarea
                v-model="form.title"
                name=""
                id=""
                class=""
                rows="3"
                maxlength="1500"
                disabled = "true"
              ></textarea>
            </div>
          </div>
        </div>
      </div>-->
      <div class="show-group-question"  >
        <div
          class="list-question-topic d-flex"
          v-for="listGroupAnswerImage in listGroupAnswerImages"
          :key="listGroupAnswerImage"
        >
          <div  class="list-question-topic-main" >
            <div class="p-2 d-flex" disabled style="">
              {{ listGroupAnswerImage.index }})
                <span class="pl-2" v-html=" listGroupAnswerImage.answertitle "></span>
            </div>
            <div class="audio-answer" v-if="listGroupAnswerImage.audio_path_view" >
                <audio
                    :src="listGroupAnswerImage.audio_path_view"
                    id="a" controls
                    class="audio-view-detail"
                />

            </div>
            <div v-if="listGroupAnswerImage.embed_audio" style="width: 400px; height: 150px; margin-bottm: 10px;" id="audio_embed_view" v-html="listGroupAnswerImage.embed_audio">
                {{ listGroupAnswerImage.embed_audio }}
              </div>

            <div class="list-answer-image" >
                <video
                    style="width: 200px; height: 200px"
                    v-if="listGroupAnswerImage.video_s3"
                    controls
                    :src="listGroupAnswerImage.video_s3"
                    id="video-preview">
                </video>
                <img style="width: auto"
                    v-if="listGroupAnswerImage.image_path_topic"
                    :src="listGroupAnswerImage.image_path_topic"
                    alt="" class="answer-topic-image"
                />
                <embed
	                class="mt-2"
                  width="400"
                  height="200"
                   v-if="listGroupAnswerImage.embed_image_video.includes('youtube')"
                  :src="listGroupAnswerImage.embed_image_video"
                  frameborder="0"
                  allowfullscreen
                />
	            <img
			            width="400"
			            height="200"
			            v-if="listGroupAnswerImage.embed_image_video && !listGroupAnswerImage.embed_image_video.includes('youtube')"
			            :src="listGroupAnswerImage.embed_image_video"
			            style="object-fit: contain; margin-top: 10px;"
	            />
                <div v-if="listGroupAnswerImage.typeQuestion != 'Writing'" class="list-answer-main d-flex flex-wrap">
                  <div
                    class="list-answer-detail col-12 col-md-6 col-lg-3"
                    v-for="(answer,index) in listGroupAnswerImage.answer"
                    :key="index"
                  >
                    <p v-if="answer.isCorrect == true " class="border-answer">{{ answer.ans_id }}.</p>
                    <p v-if="answer.isCorrect == false " >{{ answer.ans_id }}.</p>
                    <div class="">
                      <p >{{ answer.answertitle }}</p>
                      <img v-if="answer.image_answer_s3" :src="answer.image_answer_s3" alt="" />
                      <span class="pl-2 d-flex"><span v-html="answer.ans_value"></span></span>
                    </div>
                  </div>
                </div>
             </div>
          </div>
          <div class="button-answer-topic d-flex justify-content-end" >
            <ion-icon
              @click="showEditQuestion(listGroupAnswerImage.id)"
              name="pencil-outline"
              class="icon-edit mr-3"
            ></ion-icon>
            <ion-icon
              @click="deleteQuestion(listGroupAnswerImage.id)"
              name="trash-outline"
              class="icon-trash"
            ></ion-icon>
          </div>
        </div>
      </div>
      <div class="mt-3 float-right">
         <b-button
          @click="
            hideModal();
            hideModal;
          "
          style="margin-left: 1rem"
          variant="primary"
          >{{ $t("group_topic_list.button.close") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CreateQuestion from "./QuestionList/QuestionCreateModal.vue";
import CreateQuestionAutoOfExam from "./QuestionList/QuestionCreateAutoOfExamModal.vue";

import EditQuestion from "./QuestionList/QuestionEditModal.vue";
export default {
  props: ["rowTopicItem"],
  components: {
    CreateQuestion,
    EditQuestion,
    CreateQuestionAutoOfExam
  },
  data() {
    return {
      loading: false,
      classCorrectAnswer:"border-answer",
      titleTopic: '',
      isText: null,
      getAudioPath: null,
      listGroupAnswerImages: [],
      imageReRender: 0,
      cateSelected: [],
      defaultNumberAnswer: 4,
      alphabetAnswerSelected: 0,
      typeOfAnswers: ["Number", "Alphabet"],
      statusSelected: 1,
      answerOptionOfQuestions: ["One choice", "Multiple choice"],
      valueTypeOfAnswers: [
        [1, 2, 3, 4, 5, 6],
        ["A", "B", "C", "D", "E", "F"]
      ],
      valueTypeOfAnswer: [1, 2, 3, 4],
      imageUpload: "",
      embedPath: "",
      embedAudio: "",
      totalCharacter: 0,
      answerUpload: [],
      correctAnswer: [],
      file: "",
      form: {
        title: null,
        type: "Listening",
        status: "Active",
        score: null,
        difficulty: "easy",
        category: [],
        explain: "explain",
        image_path: null,
        video_path: null,
        embed_image_video: null,
        audio_path: null,
        embed_audio: null,
        answer_option: "One choice",
        answer: [],
        image: [],
        answer_text: [],
        number_answer: 4
      },
      selectedTypeAnswer: "Alphabet",
      tags: []
    };
  },
  computed: {
    ...mapState("config", ["category", "difficulty"]),
    ...mapState("topics", ["topicOneItemRes"]),
    ...mapGetters({
      getTopicListRes: "topics/topicListRes",
      getTopicOneItemRes: "topics/topicOneItemRes"
    })
  },

  methods: {
    async deleteQuestion(id) {
      await this.$store.dispatch("question/deleteQuestion", id);
        const apiRes = this.$store.state.question.responseQuestion;
        const errors = apiRes?.errors?.title || apiRes?.errors?.score || {message: apiRes?.message} || "";
        const errorFields = Object.values(errors)
      if (this.$store.state.question.responseQuestion.code !== 422) {
        this.$root.$loading.start();
        await this.getOneTopic();
        this.$root.$loading.finish();
        this.$root.toast(
          this.$t("commons.label.create_success_title"),
          "success",
          this.$t("category.message.delete_success")
        );
      } else {
        this.$root.toast(
          this.$t("questions_create.message.create_false"),
          "danger",
          this.$t(`msg.E_UC3_49`)
        );
      }
    },
    async showEditQuestion(id) {
      this.loading = true;
      await this.$store.dispatch("question/deleteExplain");
      await this.$store.dispatch("question/showEditQuestion", id);
      this.$bvModal.show("modal-edit-question");
      this.loading = false;
    },
    async showCreateQuestion() {
      this.loading = true;
      await this.$store.dispatch("question/deleteExplain");
      this.$bvModal.show("modal-create-question");
      this.loading = false;
    },
    async showCreateQuestionAutoOfExam() {
      this.loading = true;
      await this.$store.dispatch("question/deleteExplain");
      this.$bvModal.show("modal-create-question-auto-of-exam");
      this.loading = false;
    },
    hideModal() {
      this.$bvModal.hide("modal-showDetail");
    },
    // the loai cau hoi
    typeOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.type =
          e.target.options[e.target.options.selectedIndex].outerText;
      }
    },
    // do kho cau hoi
    difficultyOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.difficulty =
          e.target.options[e.target.options.selectedIndex].outerText;
      }
    },


    previewAudio() {
      let audio = document.getElementById("audio-preview");
      let reader = new FileReader();

      reader.readAsDataURL(this.file);
      reader.addEventListener("load", function() {
        audio.src = reader.result;
      });
    },
    previewAudioView() {
      let audio = document.getElementById("a");
      let reader = new FileReader();

      reader.readAsDataURL(this.file);
      reader.addEventListener("load", function() {
        audio.src = reader.result;
      });
    },
    handleAudioUpload(event) {
      this.file = event.target.files[0];
      this.form.audio_path = this.file;
      this.previewAudio();
    },
    removeImage: function() {
      this.imageUpload = null;
      this.form.image_path = null;
    },
    removeAudio: function() {
      this.file = "";
      this.form.audio_path = "";
      let audio = document.getElementById("audio-preview");
      audio.src = null;
    },
    removeAnswerImage: function(index) {
      this.answerUpload[index] = "";
      this.imageReRender += 1;
    },
    async getOneTopic() {
      await this.$store.dispatch("topics/getOneTopicTest", this.rowTopicItem);
      this.form.title = this.getTopicOneItemRes.title || "";
      this.titleTopic = this.getTopicOneItemRes.title || "";
      this.imageUpload = this.getTopicOneItemRes.image_s3 || "";
      this.embedPath = this.getTopicOneItemRes.embed_path || "";
      this.embedAudio = this.getTopicOneItemRes.embed_audio || "";
      this.file = this.getTopicOneItemRes.audio_path || "";
      this.getAudioPath = this.getTopicOneItemRes.audio_s3 || "";
      this.getVideoPath = this.getTopicOneItemRes.video_s3 || "";

      let groupItem = {
        id: null,
        answertitle: "",
        answer: [],
        image_path_topic: '',
        isText :null,
        audio_path_view: ''
      };
      let listQuestion = this.getTopicOneItemRes.questions;
      this.listGroupAnswerImages = [];
      let indexAnswer=1;
      for (let i = 0; i < listQuestion.length; i++) {
        groupItem = {
          id: listQuestion[i].id || "",
          index: indexAnswer,
          answertitle: listQuestion[i].title || "",
          answer: listQuestion[i].answer || "",
          image_path_topic: listQuestion[i].image_s3 || "",
          embed_image_video: listQuestion[i].embed_image_video || "",
          audio_s3: listQuestion[i].audio_s3 || "",
          embed_audio: listQuestion[i].embed_audio || "",
        //   isText : listQuestion[i].title || ",
          video_s3: listQuestion[i].video_s3 || "",
          audio_path_view: listQuestion[i].audio_s3 || "",
          typeQuestion : listQuestion[i].type || "",
        };
        this.listGroupAnswerImages.push(groupItem);
        indexAnswer += 1;
      }
      this.viewDetailImage = this.getTopicOneItemRes.image_path;
      this.message = this.getTopicOneItemRes.title;
      if (this.viewDetailImage != "null") {
        this.checkImageFalse = false;
        this.checkImageTrue = true;
      } else {
        this.checkImageFalse = true;
        this.checkImageTrue = false;
      }
      if (this.message != "null") {
        this.message = this.getTopicOneItemRes.title;
      } else {
        this.message = "Typing for question";
      }
    },
    backToListQuestion() {
      this.$root.$loading.start();
      this.$router.push({ name: "QuestionList" });
      this.$root.$loading.finish();
    }
  },
  async created() {
    await this.getOneTopic();
    for (let i = 0; i < this.listTags.length; i++) {
      this.tags.push({
        value: this.listTags[i].id,
        text: this.listTags[i].name
      });
    }
    await this.$root.$loading.start();
    await this.$store.dispatch("config/getCategory");

    this.$root.$loading.finish();
    await this.filterProblem();
  }
};
</script>
<style>
@import "../../assets/scss/Topics.scss";
@import "../../assets/scss/Questions.scss";

* {
  font-size: 15px;
}

.main-create-question-topic {
  width: 100%;
}
.titleTopic{
	white-space: nowrap;
	width: 600px;
	text-overflow:ellipsis;
	overflow: hidden;
}

.iframe {
  height: 250px !important;
}

/* 1) dialog chiếm 100% viewport */
#modal-showDetail___BV_modal_content_{
    height: 100vh !important;
    border-radius: 0 !important;
}

/* modal-dialog (thằng đang có modal-xl) */
#modal-showDetail___BV_modal_content_{
    /* chỉ để xác định scope, không cần gì ở đây */
}

/* bootstrap structure: .modal-dialog nằm ngoài .modal-content
   => ta target theo ancestor .modal-dialog khi nó chứa content id này */
.modal-dialog:has(#modal-showDetail___BV_modal_content_) {
    width: 100vw !important;
    max-width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
}

/* 2) content full height */
.modal-dialog:has(#modal-showDetail___BV_modal_content_) .modal-content{
    height: 100vh !important;
    border-radius: 0 !important;
}

/* 3) body scroll bên trong */
.modal-dialog:has(#modal-showDetail___BV_modal_content_) .modal-body{
    height: 100vh !important;        /* nếu có header thì trừ px ở dưới */
    overflow-y: auto !important;
}
.show-group-question {
    overflow-y: auto;
    height: auto;
    max-height: 600px;
}
</style>
